import * as React from 'react';
import * as style from './style.css';
import { IconButton, IconClose16, UIHeading2, UIText2 } from '@cian/ui-kit';
import { Link } from '../../../Layouts/parts/Link';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ModalHeader = _ref => {
  let {
    onClose,
    onClick,
    title,
    description,
    url
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: style['header'],
    children: [/*#__PURE__*/_jsxs("div", {
      className: style['heading'],
      children: [/*#__PURE__*/_jsx(UIHeading2, {
        children: title
      }), /*#__PURE__*/_jsx(UIText2, {
        children: /*#__PURE__*/_jsx(Link, {
          href: url,
          target: "_blank",
          onClick: onClick,
          children: description
        })
      })]
    }), /*#__PURE__*/_jsx(IconButton, {
      icon: /*#__PURE__*/_jsx(IconClose16, {}),
      onClick: onClose
    })]
  });
};